// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plane-wrapper[data-v-c4d5d718] {\n  width: 60px;\n  height: 60px;\n  background-color: #3ff9dc;\n  display: inline-block;\n  animation: plane-loader-c4d5d718 1.2s infinite ease-in-out;\n}\n@keyframes plane-loader-c4d5d718 {\n0% {\n    transform: perspective(120px);\n}\n50% {\n    transform: perspective(120px) rotateY(180deg);\n}\n100% {\n    transform: perspective(120px) rotateY(180deg) rotateX(180deg);\n}\n}", ""]);
// Exports
module.exports = exports;
